import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  url;
  fragments = [
    { label: 'Active Ingredients', url: 'active-ingredient' },
    { label: 'Forms and concentrations', url: 'forms' },
    { label: 'Indication uses and doses', url: 'indecation' },
    { label: 'Drug Interaction', url: 'interaction' },
    { label: 'Most Important Trials', url: 'trials' },
    { label: 'Guidelines', url: 'guidelines' },
  ];
  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      (res)=>{
       this.url = res.name;
      }
    )
  }
}
